module.exports = __webpack_public_path__ + "static/img/noImg.35e7aae6.png";